// ! qo'qon xon o'rdasi
import xonsaroy1 from "../../photos/uzb_farg_xonsaroy1.webp";
import xonsaroy2 from "../../photos/uzb_farg_xonsaroy2.webp";
import xonsaroy3 from "../../photos/uzb_farg_xonsaroy3.webp";

// ! andijon bobur muzeyi
import bobur1 from "../../photos/uzb_farg_bobur1.webp";
import bobur2 from "../../photos/uzb_farg_bobur2.webp";
import bobur3 from "../../photos/uzb_farg_bobur3.webp";

// ! marg'ilon yodgorlik ko'chasi
import margilon1 from "../../photos/uzb_farg_margilon1.webp";
import margilon2 from "../../photos/uzb_farg_margilon2.webp";
import margilon3 from "../../photos/uzb_farg_margilon3.webp";

// ! rishton kulolchilik markazi
import rishton1 from "../../photos/uzb_farg_rishton1.webp";
import rishton2 from "../../photos/uzb_farg_rishton2.webp";
import rishton3 from "../../photos/uzb_farg_rishton3.webp";

// ! namangan mulla qirg'iz masjidi
import namangan1 from "../../photos/uzb_farg_namangan1.webp";
import namangan2 from "../../photos/uzb_farg_namangan2.webp";
import namangan3 from "../../photos/uzb_farg_namangan3.webp";

// ! axsikent qadimiy shahri
import axsikent1 from "../../photos/uzb_farg_axsikent1.webp";
import axsikent2 from "../../photos/uzb_farg_axsikent2.webp";
import axsikent3 from "../../photos/uzb_farg_axsikent3.webp";

const fargonaVodiysi = {
    uz: {
        key: "fargona-vodiysi",
        title: "Farg‘ona vodiysi — uch viloyatning tarixiy xazinasi",

        intro: `
Farg‘ona vodiysi — Farg‘ona, Andijon va Namangan viloyatlarini o‘z ichiga olgan, tog‘lar bilan o‘ralgan serhosil hudud.
Bu yer qadimdan hunarmandchilik, savdo va ilm-fan markazi bo‘lib, Bobur imperiyasining ham beshigi hisoblanadi.
  `,

        history: `
Farg‘ona vodiysi Markaziy Osiyoning eng qadimiy va serhosil o‘lkalaridan biri bo‘lib, uning tarixi miloddan avvalgi davrlarga borib taqaladi. Qadimda bu yerda Dovon (Farg‘ona) davlati mavjud bo‘lgan va u Xitoy manbalarida "samoviy otlar" vatani sifatida tilga olingan.

Buyuk Ipak yo‘lining muhim tarmoqlaridan biri aynan Farg‘ona vodiysidan o‘tgan, shu sababli bu yerda savdo shaharlari — Axsikent, Qo‘qon, Andijon va Marg‘ilon rivojlangan.

Vodiyning jahon tarixidagi eng muhim o‘rni Zahiriddin Muhammad Bobur bilan bog‘liq — u Andijonda tug‘ilgan va keyinchalik Hindistonda Boburiylar imperiyasiga asos solgan.

XVIII–XIX asrlarda Qo‘qon xonligi vodiyning siyosiy markaziga aylandi va bu davrda ko‘plab saroy, masjid va madrasalar qurildi. Marg‘ilon esa asrlar davomida ipakchilik va hunarmandchilikning markazi bo‘lib kelgan, Rishton esa noyob kulolchilik maktabi bilan mashhur.

Bugungi kunda Farg‘ona vodiysi O‘zbekistonning eng zich aholi yashaydigan va tarixiy-madaniy jihatdan boy hududlaridan biri hisoblanadi.
`,
        sections: [
            {
                title: "Xudoyorxon o‘rdasi — Qo‘qon",

                content: `
Xudoyorxon o‘rdasi Qo‘qon xonligining so‘nggi va eng hashamatli saroyi bo‘lib, Farg‘ona vodiysining eng mashhur me’moriy yodgorligi hisoblanadi.

Saroy o‘z davrida Markaziy Osiyodagi eng ulkan hukmdorlik qarorgohlaridan biri bo‘lgan va Qo‘qon xonligining qudratini namoyish etgan.

Bugungi kunda saroyning bir qismi muzey sifatida faoliyat yuritadi.
    `,

                details: `
Saroy 1863–1873-yillarda Qo‘qon xoni Xudoyorxon buyrug‘i bilan qurilgan.

📌 Arxitektura:
- Asl holida 7 hovli va 100 dan ortiq xonadan iborat bo‘lgan
- Rangdor koshinlar va ganchkori bezaklar
- Baland peshtoq va minoralar

📌 Tarixiy ahamiyati:
- Qo‘qon xonligining oxirgi rezidensiyasi bo‘lgan
- Rossiya imperiyasi bosqinidan so‘ng qisman vayron qilingan
- Bugungi kunda saroyning taxminan to‘rtdan bir qismi saqlangan

Saroy ichki bezaklari — ganchkorlik va naqqoshlik san’ati bilan mahalliy usta Mir Ubaydulla boshchiligidagi hunarmandlar tomonidan ishlangan.
    `,
                facts: [
                    "Qo‘qon shahrida joylashgan",
                    "1863–1873-yillarda qurilgan",
                    "Xudoyorxon buyrug‘i bilan barpo etilgan",
                    "Asl holida 7 hovli va 100+ xonaga ega bo‘lgan",
                    "Qo‘qon xonligining so‘nggi rezidensiyasi",
                    "Ganchkorlik va koshinkorlik bilan bezatilgan",
                    "Rossiya bosqinidan so‘ng qisman vayron bo‘lgan",
                    "Hozirda mahalliy o‘lkashunoslik muzeyi joylashgan",
                    "Farg‘ona vodiysining eng mashhur saroyi",
                    "XIX asr me’morchiligining noyob namunasi",
                    "Ichki bezaklarda o‘simliksimon naqshlar bor",
                    "Baland peshtoqi bilan ajralib turadi",
                    "Qo‘qon xonligi tarixini o‘rganish markazi",
                    "Har yili minglab sayyohlar tashrif buyuradi",
                    "Vodiyning siyosiy tarixi ramzi hisoblanadi"
                ],
                images: [xonsaroy1, xonsaroy2, xonsaroy3,]
            },

            {
                title: "Bobur bog‘i va muzeyi — Andijon",

                content: `
Bobur bog‘i va muzeyi Andijon shahrida joylashgan bo‘lib, Boburiylar sulolasi asoschisi Zahiriddin Muhammad Boburning tug‘ilgan shahriga bag‘ishlangan.

Bu maskan Bobur hayoti, ijodi va Boburiylar imperiyasi tarixini o‘rganish uchun muhim ilmiy-madaniy markaz hisoblanadi.

Bog‘ zamonaviy landshaft dizayni bilan tarixiy ma’noni uyg‘unlashtirgan holda barpo etilgan.
    `,

                details: `
Bobur muzeyi 1994-yilda, Boburning 510 yilligi munosabati bilan tashkil etilgan.

📌 Ekspozitsiya:
- Bobur davriga oid qo‘lyozmalar va nusxalar
- "Boburnoma" asariga bag‘ishlangan bo‘lim
- Boburiylar imperiyasi xaritalari
- Davr kiyimlari va qurollari namunalari

📌 Tarixiy ahamiyati:
- Bobur 1483-yilda aynan Andijonda tug‘ilgan
- U yoshligidayoq Farg‘ona taxtiga o‘tirgan
- Keyinchalik Hindistonda Boburiylar imperiyasiga asos solgan

Bog‘ hududida Boburning haykali va suv inshootlari joylashgan bo‘lib, u mahalliy aholi va sayyohlar uchun sevimli dam olish maskaniga aylangan.
    `,
                facts: [
                    "Andijon shahrida joylashgan",
                    "1994-yilda tashkil etilgan",
                    "Bobur 1483-yilda Andijonda tug‘ilgan",
                    "\"Boburnoma\" asariga bag‘ishlangan bo‘lim mavjud",
                    "Boburiylar imperiyasi xaritalari saqlanadi",
                    "Bobur haykali bog‘ markazida joylashgan",
                    "Zamonaviy landshaft dizayni bilan qurilgan",
                    "Davr qo‘lyozmalari nusxalari namoyish etiladi",
                    "Andijonning eng mashhur madaniy maskani",
                    "Har yili minglab mehmonlar tashrif buyuradi",
                    "Maktab o‘quvchilari uchun ta’lim markazi",
                    "Boburiylar tarixi bilan tanishish imkoniyati",
                    "Bog‘-park hududi bilan o‘ralgan",
                    "Milliy g‘urur ramzi sifatida qadrlanadi",
                    "Farg‘ona vodiysining madaniy markazlaridan biri"
                ],
                images: [bobur1, bobur2, bobur3,]
            },

            {
                title: "Yodgorlik ko‘chasi va ipakchilik — Marg‘ilon",

                content: `
Marg‘ilon — Farg‘ona vodiysining eng qadimiy shaharlaridan biri bo‘lib, asrlar davomida ipakchilik va hunarmandchilikning jahon miqyosidagi markazi hisoblangan.

Shahar tarixiy markazidagi Yodgorlik ko‘chasi noyob yog‘och me’morchiligi bilan mashhur bo‘lib, mahalliy hunarmandchilik an’analarini o‘zida saqlab qolgan.

Marg‘ilon "xonatlas" mato ishlab chiqarish maskani sifatida butun dunyoga tanilgan.
    `,

                details: `
Marg‘ilon Buyuk Ipak yo‘lining muhim bekatlaridan biri bo‘lgan va shahar nomi qadimgi manbalarda ham tilga olinadi.

📌 Ipakchilik an’anasi:
- "Yodgorlik" ipak fabrikasi 100 yildan ortiq tarixga ega
- Xonatlas — noyob rang-barang ipak mato — shu yerda ishlab chiqariladi
- An’anaviy usulda ipak qurti boqilib, mato to‘qiladi

📌 Yodgorlik ko‘chasi:
- XIX–XX asr boshlariga oid yog‘och uylar saqlangan
- Naqqoshlik san’ati bilan bezatilgan eshik va ustunlar
- Mahalliy me’morchilik uslubining noyob namunasi

Shahar hozirda ham an’anaviy hunarmandchilik markazlaridan biri bo‘lib qolmoqda, bu yerda ustalar avloddan-avlodga o‘tib kelayotgan mahoratni davom ettirmoqda.
    `,
                facts: [
                    "Farg‘ona vodiysida joylashgan qadimiy shahar",
                    "Buyuk Ipak yo‘lining muhim bekati bo‘lgan",
                    "Xonatlas mato ishlab chiqarish markazi",
                    "\"Yodgorlik\" ipak fabrikasi 100 yildan ortiq tarixga ega",
                    "Yodgorlik ko‘chasida yog‘och uylar saqlangan",
                    "An’anaviy naqqoshlik san’ati rivojlangan",
                    "Ipak qurti boqish an’anasi hozirgacha davom etadi",
                    "O‘zbek milliy matolarining asosiy ishlab chiqarish markazi",
                    "Hunarmandchilik ustaxonalari sayyohlar uchun ochiq",
                    "Mahalliy me’morchilik uslubi noyob hisoblanadi",
                    "Farg‘ona vodiysining hunarmandchilik poytaxti",
                    "Ipak matolari dunyoning ko‘plab davlatlariga eksport qilinadi",
                    "Shahar tarixi bir necha ming yillikni qamrab oladi",
                    "An’anaviy bozorlari bilan ham mashhur",
                    "Milliy hunarmandchilikni saqlab qolgan noyob maskan"
                ],
                images: [margilon1, margilon2, margilon3,]
            },

            {
                title: "Rishton kulolchilik markazi",

                content: `
Rishton — Farg‘ona vodiysidagi qadimiy shahar bo‘lib, o‘zining noyob kulolchilik maktabi bilan butun dunyoga mashhur.

Bu yerdagi maxsus tuproq va sirlash texnikasi Rishton kulolchiligini boshqa maktablardan ajratib turadi — ishlar ko‘pincha o‘ziga xos moviy-yashil rangda bezatiladi.

Shahar hozirda ham amaliy san’at ustaxonalari va muzeylari bilan sayyohlarni o‘ziga jalb qiladi.
    `,

                details: `
Rishton kulolchilik an’anasi 800 yildan ortiq tarixga ega bo‘lib, u avloddan-avlodga o‘tib kelmoqda.

📌 O‘ziga xosligi:
- Mahalliy "zang" nomli maxsus tuproq faqat shu hududda uchraydi
- An’anaviy ishqor asosidagi sirlash texnologiyasi qo‘llaniladi
- Mashhur "ishqor" va "lojuvard" ranglari xarakterli

📌 Mashhur ustalar:
- Rishton kulolchilik sulolalari asrlar davomida mahoratni saqlab kelgan
- Zahid Muhtorov kabi ustalar zamonaviy davrda maktabni dunyoga tanitgan

📌 Muzey va ustaxonalar:
Shaharda kulolchilik muzeyi va bir nechta faol ustaxonalar mavjud bo‘lib, sayyohlar mahsulot tayyorlash jarayonini bevosita kuzatishlari mumkin.
    `,
                facts: [
                    "Farg‘ona vodiysida, Farg‘ona shahri yaqinida joylashgan",
                    "Kulolchilik an’anasi 800 yildan ortiq tarixga ega",
                    "Mahalliy \"zang\" tuprog‘i faqat shu yerda uchraydi",
                    "Moviy-yashil (\"ishqor\") rang bilan mashhur",
                    "An’anaviy sirlash texnologiyasi qo‘llaniladi",
                    "Kulolchilik sulolalari avloddan-avlodga o‘tadi",
                    "Zamonaviy ustalar maktabni dunyoga tanitgan",
                    "Shaharda kulolchilik muzeyi mavjud",
                    "Faol hunarmandchilik ustaxonalari ishlaydi",
                    "Mahsulotlar dunyoning ko‘plab muzeylarida namoyish etiladi",
                    "O‘zbek amaliy san’atining noyob maktabi",
                    "Sayyohlar ishlab chiqarish jarayonini kuzatishi mumkin",
                    "Rishton kulolchiligi milliy meros sifatida e’tirof etilgan",
                    "Har yili kulolchilik festivali o‘tkaziladi",
                    "Farg‘ona vodiysining amaliy san’at markazi"
                ],
                images: [rishton1, rishton2, rishton3,]
            },

            {
                title: "Mulla Qirg‘iz masjidi — Namangan",

                content: `
Mulla Qirg‘iz masjidi Namangan shahrining eng yirik va ulug‘vor tarixiy masjidlaridan biri bo‘lib, o‘z davrida shaharning diniy va ta’lim markazi hisoblangan.

Masjid o‘zining ulkan peshtoqi va nafis g‘isht bezaklari bilan Farg‘ona vodiysi me’morchiligining yorqin namunasi sifatida ajralib turadi.

Bugungi kunda ham masjid faol ibodatxona bo‘lib xizmat qiladi.
    `,

                details: `
Masjid XIX asrning ikkinchi yarmida qurilgan bo‘lib, uning qurilishini mahalliy boy savdogar homiylik qilgan degan ma’lumotlar mavjud.

📌 Arxitektura xususiyatlari:
- Ulkan peshtoq va baland gumbaz
- Pishiq g‘ishtdan ishlangan geometrik naqshlar
- Ichki zalda yog‘och ustunlar va naqqoshlik
- Vodiy uslubiga xos serhasham bezaklar

📌 Tarixiy ahamiyati:
- O‘z davrida shahar ta’lim markazi bo‘lgan
- Namanganning diniy hayotida markaziy o‘rin tutgan
- Sovet davrida qisman boshqa maqsadlarda foydalanilgan, keyinchalik qayta tiklangan

Masjid Namanganning shahar markazidagi eng muhim tarixiy diqqatga sazovor joylardan biri hisoblanadi.
    `,
                facts: [
                    "Namangan shahrida joylashgan",
                    "XIX asrning ikkinchi yarmida qurilgan",
                    "Farg‘ona vodiysidagi eng yirik masjidlardan biri",
                    "Pishiq g‘ishtdan ishlangan naqshlari bilan mashhur",
                    "Ulkan peshtoq va baland gumbazga ega",
                    "Ichki zalda yog‘och ustunlar saqlangan",
                    "O‘z davrida ta’lim markazi bo‘lgan",
                    "Namanganning diniy hayoti markazi hisoblangan",
                    "Sovet davrida qisman boshqa maqsadda foydalanilgan",
                    "Keyinchalik asl holiga qaytarilgan",
                    "Bugungi kunda faol masjid sifatida ishlaydi",
                    "Vodiy me’morchiligi uslubining yorqin namunasi",
                    "Namanganning eng mashhur tarixiy obidasi",
                    "Mahalliy aholi tomonidan muntazam ziyorat qilinadi",
                    "Shahar markazida joylashgani uchun ko‘p tashrif buyuriladi"
                ],
                images: [namangan1, namangan2, namangan3,]
            },

            {
                title: "Axsikent qadimiy shahri",

                content: `
Axsikent — Farg‘ona vodiysining eng qadimiy va bir vaqtlar eng yirik shaharlaridan biri bo‘lib, o‘rta asrlarda vodiyning poytaxti hisoblangan.

Bugungi kunda shahar xarobalar holida saqlanib qolgan bo‘lib, u arxeologlar uchun boy ilmiy manba hisoblanadi.

Axsikent Farg‘ona vodiysining qadimiy tsivilizatsiyasini o‘rganishda kalit ahamiyatga ega.
    `,

                details: `
Axsikent miloddan avvalgi davrlardan boshlab mavjud bo‘lgan bo‘lib, o‘rta asrlarda Farg‘ona viloyatining bosh shahri sifatida gullab-yashnagan.

📌 Tarixiy ma’lumot:
- Shahar Sirdaryo bo‘yida strategik joyda joylashgan bo‘lgan
- Buyuk Ipak yo‘lining muhim bekati bo‘lgan
- IX–XII asrlarda o‘z rivojining cho‘qqisiga chiqqan

📌 Vayron bo‘lishi:
1219-yilda Chingizxon qo‘shinlari shaharni vayron qilgan, biroq u qisman qayta tiklangan. Keyinchalik XVI asrda zilzila natijasida shahar butunlay tashlab ketilgan.

📌 Arxeologik ahamiyati:
- Qazilmalar davomida kulolchilik, tanga va me’moriy topilmalar aniqlangan
- Shahar qatlamlari orqali Farg‘ona vodiysi tarixini bosqichma-bosqich o‘rganish mumkin

Bugungi kunda Axsikent hududida arxeologik qazishma ishlari davom etmoqda va u ochiq osmon ostidagi muzey sifatida qaraladi.
    `,
                facts: [
                    "Namangan viloyatida, Sirdaryo bo‘yida joylashgan",
                    "Farg‘ona vodiysining qadimiy poytaxti bo‘lgan",
                    "Miloddan avvalgi davrlardan mavjud bo‘lgan",
                    "IX–XII asrlarda gullab-yashnagan",
                    "Buyuk Ipak yo‘lining muhim bekati bo‘lgan",
                    "1219-yilda Chingizxon tomonidan vayron qilingan",
                    "XVI asr zilzilasidan so‘ng butunlay tashlab ketilgan",
                    "Arxeologik qazishmalar hozir ham davom etmoqda",
                    "Kulolchilik va tanga topilmalari aniqlangan",
                    "Ochiq osmon ostidagi muzey sifatida qaraladi",
                    "Farg‘ona vodiysi tarixini o‘rganishda kalit maskan",
                    "Shahar qatlamlari bir necha davrni o‘z ichiga oladi",
                    "Tarixchilar va arxeologlar uchun muhim manba",
                    "Vodiyning qadimiy tsivilizatsiyasidan dalolat beradi",
                    "Namanganning eng qadimiy tarixiy yodgorligi"
                ],
                images: [axsikent1, axsikent2, axsikent3,]
            }
        ]
    },

    ru: {
        key: "fargona-vodiysi",
        title: "Ферганская долина — историческое сокровище трёх регионов",

        intro: `
Ферганская долина — это плодородный регион, окружённый горами, который включает Ферганскую, Андижанскую и Наманганскую области.

С древних времён этот край был центром ремесла, торговли и науки, а также считается родиной империи Бабура.
`,

        history: `
Ферганская долина — один из самых древних и плодородных регионов Центральной Азии, история которого уходит в глубину веков. В древности здесь существовало государство Давань (Фергана), которое в китайских источниках упоминалось как родина знаменитых «небесных коней».

Один из важных маршрутов Великого Шёлкового пути проходил именно через Ферганскую долину, благодаря чему здесь развивались торговые города — Ахсикент, Коканд, Андижан и Маргилан.

Всемирное историческое значение долины тесно связано с Захириддином Мухаммадом Бабуром. Он родился в Андижане и позже основал империю Великих Моголов в Индии.

В XVIII–XIX веках Кокандское ханство стало политическим центром долины. В этот период были построены многочисленные дворцы, мечети и медресе. Маргилан на протяжении веков оставался центром производства шёлка и народных ремёсел, а Риштан прославился своей уникальной школой керамики.

Сегодня Ферганская долина является одним из самых густонаселённых и культурно богатых регионов Узбекистана, где сочетаются древние традиции, историческое наследие и современная жизнь.
`,

        sections: [
            {
                title: "Дворец Худоярхана — Коканд",

                content: `
Дворец Худоярхана — это последний и самый роскошный дворец Кокандского ханства, который считается одним из самых известных архитектурных памятников Ферганской долины.

В своё время дворец был одной из крупнейших правительственных резиденций Центральной Азии и символизировал могущество и богатство Кокандского ханства.

Сегодня часть дворца используется как исторический музей.
`,

                details: `
Дворец был построен в 1863–1873 годах по приказу кокандского хана Худоярхана.

📌 Архитектура:
- Первоначально состоял из 7 дворов и более 100 помещений
- Украшен цветной керамикой и резным ганческим декором
- Имеет высокий парадный портал и декоративные башни

📌 Историческое значение:
- Был последней официальной резиденцией Кокандского ханства
- Частично разрушен после завоевания Российской империей
- Сегодня сохранилась примерно четверть первоначального комплекса

Внутреннее оформление дворца — резьба по ганчу и декоративная роспись — было выполнено местными мастерами под руководством известного мастера Мир Убайдуллы.
`,

                facts: [
                    "Расположен в городе Коканд",
                    "Построен в 1863–1873 годах",
                    "Возведён по приказу Худоярхана",
                    "Первоначально имел 7 дворов и более 100 комнат",
                    "Последняя резиденция Кокандского ханства",
                    "Украшен ганжевой резьбой и керамическими узорами",
                    "Частично разрушен после завоевания Российской империей",
                    "Сегодня здесь расположен краеведческий музей",
                    "Один из самых известных дворцов Ферганской долины",
                    "Уникальный пример архитектуры XIX века",
                    "Внутренние украшения имеют растительные орнаменты",
                    "Известен своим высоким парадным порталом",
                    "Важный центр изучения истории Кокандского ханства",
                    "Ежегодно посещается тысячами туристов",
                    "Символ политической истории Ферганской долины"
                ],

                images: [xonsaroy1, xonsaroy2, xonsaroy3,]
            },

            {
                title: "Парк и музей Бабура — Андижан",

                content: `
Парк и музей Бабура расположены в городе Андижан и посвящены Захириддину Мухаммаду Бабуру — основателю династии Великих Моголов и уроженцу этого города.

Это место является важным культурно-научным центром, где изучаются жизнь Бабура, его творчество и история империи Великих Моголов.

Парк создан с сочетанием современного ландшафтного дизайна и исторического значения.
`,

                details: `
Музей Бабура был открыт в 1994 году в честь 510-летия со дня рождения великого правителя и поэта.

📌 Экспозиция:
- Рукописи и копии, связанные с эпохой Бабура
- Раздел, посвящённый произведению «Бабурнома»
- Карты империи Великих Моголов
- Образцы одежды и оружия того периода

📌 Историческое значение:
- Бабур родился в Андижане в 1483 году
- В юном возрасте он стал правителем Ферганской долины
- Позже основал империю Великих Моголов в Индии

На территории парка расположены памятник Бабуру, водные сооружения и зоны отдыха. Сегодня это одно из любимых мест жителей города и туристов.
`,

                facts: [
                    "Расположен в городе Андижан",
                    "Открыт в 1994 году",
                    "Бабур родился в Андижане в 1483 году",
                    "Имеет раздел, посвящённый произведению «Бабурнома»",
                    "В музее представлены карты империи Великих Моголов",
                    "В центре парка установлен памятник Бабуру",
                    "Создан с современным ландшафтным дизайном",
                    "Представлены копии исторических рукописей",
                    "Один из самых известных культурных объектов Андижана",
                    "Ежегодно принимает тысячи посетителей",
                    "Используется как образовательный центр",
                    "Позволяет узнать историю империи Великих Моголов",
                    "Окружён красивой парковой зоной",
                    "Считается символом национальной гордости",
                    "Один из культурных центров Ферганской долины"
                ],

                images: [bobur1, bobur2, bobur3,]
            },
            {
                title: "Улица Йодгорлик и шелководство — Маргилан",

                content: `
Маргилан — один из древнейших городов Ферганской долины, который на протяжении веков был всемирно известным центром шелководства и ремесел.

Улица Йодгорлик в исторической части города известна своей уникальной деревянной архитектурой и сохраняет традиции местного народного мастерства.

Маргилан знаменит во всём мире как центр производства «хонатлас» — традиционной узбекской шелковой ткани.
`,

                details: `
Маргилан был одним из важных пунктов Великого Шёлкового пути, а название города упоминается ещё в древних исторических источниках.

📌 Традиции шелководства:
- Шёлковая фабрика «Йодгорлик» имеет более чем 100-летнюю историю
- Здесь производится «хонатлас» — уникальная яркая шелковая ткань
- Шёлк создаётся традиционным способом: выращивание шелкопряда и ручное ткачество

📌 Улица Йодгорлик:
- Сохранились деревянные дома XIX — начала XX века
- Двери и колонны украшены традиционной резьбой
- Представляет уникальный образец местной архитектуры

Сегодня Маргилан остаётся одним из главных центров традиционного ремесла. Мастера продолжают передавать свои навыки из поколения в поколение, сохраняя древние технологии.
`,

                facts: [
                    "Древний город, расположенный в Ферганской долине",
                    "Был важным пунктом Великого Шёлкового пути",
                    "Центр производства ткани хонатлас",
                    "Шёлковая фабрика «Йодгорлик» имеет более чем 100-летнюю историю",
                    "На улице Йодгорлик сохранились деревянные дома",
                    "Здесь развита традиционная резьба по дереву",
                    "Традиция выращивания шелкопряда сохраняется до сих пор",
                    "Один из главных центров производства национальных тканей Узбекистана",
                    "Мастерские ремесленников открыты для туристов",
                    "Местная архитектура считается уникальной",
                    "Ремесленная столица Ферганской долины",
                    "Шёлковые ткани экспортируются во многие страны мира",
                    "История города насчитывает несколько тысяч лет",
                    "Город также известен своими традиционными рынками",
                    "Уникальное место, сохранившее национальные ремесленные традиции"
                ],

                images: [margilon1, margilon2, margilon3,]
            },
            {
                title: "Риштанский центр керамики",

                content: `
Риштан — древний город в Ферганской долине, который известен во всём мире своей уникальной школой керамики.

Особая местная глина и традиционная техника глазурования делают риштанскую керамику неповторимой — изделия обычно украшаются характерными сине-зелёными оттенками.

Сегодня город продолжает привлекать туристов своими мастерскими декоративно-прикладного искусства и музеями.
`,

                details: `
Традиция риштанской керамики насчитывает более 800 лет и передаётся из поколения в поколение.

📌 Особенности:
- Специальная местная глина «занг» встречается только в этом регионе
- Используется традиционная технология глазурования на основе щёлочи
- Характерны знаменитые цвета «ишкор» и «лочувард»

📌 Известные мастера:
- Династии риштанских гончаров веками сохраняют традиции мастерства
- Такие мастера, как Захид Мухторов, помогли прославить школу керамики в современном мире

📌 Музеи и мастерские:
В городе работают музей керамики и несколько действующих мастерских, где туристы могут увидеть процесс изготовления изделий своими глазами.
`,

                facts: [
                    "Расположен в Ферганской долине недалеко от города Фергана",
                    "Традиция керамики насчитывает более 800 лет",
                    "Местная глина «занг» встречается только здесь",
                    "Известен сине-зелёными оттенками глазури",
                    "Используется традиционная техника глазурования",
                    "Гончарное мастерство передаётся из поколения в поколение",
                    "Современные мастера прославили школу на международном уровне",
                    "В городе существует музей керамики",
                    "Работают традиционные ремесленные мастерские",
                    "Изделия представлены во многих музеях мира",
                    "Уникальная школа узбекского декоративно-прикладного искусства",
                    "Туристы могут наблюдать процесс изготовления изделий",
                    "Риштанская керамика признана частью национального наследия",
                    "Каждый год проводится фестиваль керамики",
                    "Один из главных центров прикладного искусства Ферганской долины"
                ],

                images: [rishton1, rishton2, rishton3,]
            },
            {
                title: "Мечеть Мулла Киргиз — Наманган",

                content: `
Мечеть Мулла Киргиз — одна из крупнейших и величественных исторических мечетей города Наманган. В своё время она являлась важным религиозным и образовательным центром города.

Мечеть выделяется своим большим порталом и изящным кирпичным декором, представляя яркий пример архитектуры Ферганской долины.

Сегодня мечеть продолжает функционировать как действующий храм.
`,

                details: `
Мечеть была построена во второй половине XIX века. Согласно историческим сведениям, строительство было поддержано местным богатым купцом.

📌 Архитектурные особенности:
- Большой парадный портал и высокий купол
- Геометрические узоры из обожжённого кирпича
- Деревянные колонны и резьба внутри зала
- Богатое декоративное оформление в стиле Ферганской долины

📌 Историческое значение:
- В своё время была центром образования города
- Занимала важное место в религиозной жизни Намангана
- В советский период частично использовалась для других целей, а позже была восстановлена

Мечеть является одной из главных исторических достопримечательностей Намангана и важной частью культурного наследия города.
`,

                facts: [
                    "Расположена в городе Наманган",
                    "Построена во второй половине XIX века",
                    "Одна из крупнейших мечетей Ферганской долины",
                    "Известна узорами из обожжённого кирпича",
                    "Имеет большой портал и высокий купол",
                    "Внутри сохранились деревянные колонны",
                    "В своё время была образовательным центром",
                    "Была центром религиозной жизни Намангана",
                    "В советский период использовалась частично для других целей",
                    "Позже была восстановлена",
                    "Сегодня действует как мечеть",
                    "Является ярким примером архитектуры долины",
                    "Одна из самых известных исторических достопримечательностей Намангана",
                    "Регулярно посещается местными жителями",
                    "Благодаря расположению в центре города привлекает множество посетителей"
                ],

                images: [namangan1, namangan2, namangan3,]
            },
            {
                title: "Древний город Ахсикент",

                content: `
Ахсикент — один из самых древних и когда-то крупнейших городов Ферганской долины, который в средние века считался столицей региона.

Сегодня город сохранился в виде руин и является ценным научным источником для археологов.

Ахсикент имеет ключевое значение в изучении древней цивилизации Ферганской долины.
`,

                details: `
Ахсикент существовал ещё с древних времён и в средние века достиг своего расцвета, став главным городом Ферганской области.

📌 Исторические сведения:
- Город находился в стратегическом месте на берегу Сырдарьи
- Был важным пунктом Великого Шёлкового пути
- Достиг наивысшего развития в IX–XII веках

📌 Разрушение города:
В 1219 году город был разрушен войсками Чингисхана, однако позже частично восстановлен. В XVI веке после сильного землетрясения город был окончательно покинут.

📌 Археологическое значение:
- Во время раскопок были обнаружены керамика, монеты и архитектурные находки
- Слои города позволяют изучать историю Ферганской долины на разных этапах

Сегодня на территории Ахсикента продолжаются археологические исследования, и он рассматривается как музей под открытым небом.
`,

                facts: [
                    "Расположен в Наманганской области на берегу Сырдарьи",
                    "Был древней столицей Ферганской долины",
                    "Существовал ещё до нашей эры",
                    "Расцвет города пришёлся на IX–XII века",
                    "Был важным пунктом Великого Шёлкового пути",
                    "В 1219 году разрушен войсками Чингисхана",
                    "После землетрясения XVI века город был окончательно покинут",
                    "Археологические раскопки продолжаются и сегодня",
                    "Обнаружены керамические изделия и древние монеты",
                    "Считается музеем под открытым небом",
                    "Ключевое место для изучения истории Ферганской долины",
                    "Слои города охватывают несколько исторических периодов",
                    "Важный источник для историков и археологов",
                    "Свидетельствует о древней цивилизации региона",
                    "Один из самых древних исторических памятников Намангана"
                ],

                images: [axsikent1, axsikent2, axsikent3,]
            }
        ]
    },

    en: {
        key: "fargona-vodiysi",
        title: "Fergana Valley — A Historic Treasure of Three Regions",

        intro: `
The Fergana Valley is a fertile region surrounded by mountains, including the Fergana, Andijan, and Namangan regions.

For centuries, this land has been a center of trade, craftsmanship, and science, and it is also known as the birthplace of Babur's empire.
`,

        history: `
The Fergana Valley is one of the oldest and most fertile regions of Central Asia, with a history dating back to ancient times. In ancient periods, the state of Davan (Fergana) existed here and was mentioned in Chinese sources as the homeland of the famous "heavenly horses".

One of the important branches of the Great Silk Road passed through the Fergana Valley, which contributed to the development of ancient cities such as Aksikent, Kokand, Andijan, and Margilan.

The valley has an important place in world history due to Zahiriddin Muhammad Babur. He was born in Andijan and later founded the Mughal Empire in India.

During the XVIII–XIX centuries, the Kokand Khanate became the political center of the valley. Many palaces, mosques, and madrasas were built during this period. Margilan became famous as a center of silk production and traditional crafts, while Rishtan became known for its unique pottery school.

Today, the Fergana Valley is one of the most densely populated and culturally rich regions of Uzbekistan.
`,

        sections: [
            {
                title: "Khudoyarkhan Palace — Kokand",

                content: `
Khudoyarkhan Palace is the last and one of the most magnificent palaces of the Kokand Khanate and is considered one of the most famous architectural monuments of the Fergana Valley.

During its time, the palace was one of the largest royal residences in Central Asia and represented the power and wealth of the Kokand Khanate.

Today, part of the palace operates as a historical museum.
`,

                details: `
The palace was built between 1863 and 1873 by the order of Kokand Khan Khudoyarkhan.

📌 Architectural features:
- Originally consisted of 7 courtyards and more than 100 rooms
- Decorated with colorful ceramic tiles and carved plaster decorations
- Featured a high entrance portal and decorative towers

📌 Historical importance:
- It was the last official residence of the Kokand Khanate
- Partially destroyed after the Russian Empire's conquest
- Today, approximately one quarter of the original complex remains

The interior decoration of the palace, including carved plasterwork and traditional paintings, was created by local craftsmen under the leadership of the famous master Mir Ubaydulla.
`,

                facts: [
                    "Located in the city of Kokand",
                    "Built between 1863 and 1873",
                    "Constructed by order of Khudoyarkhan",
                    "Originally had 7 courtyards and more than 100 rooms",
                    "The last residence of the Kokand Khanate",
                    "Decorated with carved plaster and ceramic ornaments",
                    "Partially destroyed after the Russian Empire conquest",
                    "Currently houses a local history museum",
                    "One of the most famous palaces of the Fergana Valley",
                    "A unique example of 19th-century architecture",
                    "Interior decorations include floral patterns",
                    "Famous for its high entrance portal",
                    "An important center for studying the history of the Kokand Khanate",
                    "Visited by thousands of tourists every year",
                    "A symbol of the political history of the Fergana Valley"
                ],

                images: [xonsaroy1, xonsaroy2, xonsaroy3,]
            },
            {
                title: "Babur Park and Museum — Andijan",

                content: `
Babur Park and Museum is located in Andijan and is dedicated to Zahiriddin Muhammad Babur, the founder of the Mughal Empire and one of the greatest historical figures of Central Asia.

This place is an important cultural and educational center for learning about Babur's life, his works, and the history of the Mughal Empire.

The park combines modern landscape design with historical significance and has become one of the most popular cultural attractions in Andijan.
`,

                details: `
The Babur Museum was established in 1994 on the occasion of the 510th anniversary of Babur's birth.

📌 Museum exhibition:
- Manuscripts and copies related to Babur's era
- A special section dedicated to the work "Baburnama"
- Maps of the Mughal Empire
- Examples of historical clothing and weapons

📌 Historical importance:
- Zahiriddin Muhammad Babur was born in Andijan in 1483
- He became the ruler of the Fergana region at a young age
- Later, he founded the Mughal Empire in India

The park includes a monument to Babur and beautiful water features, making it a favorite recreation place for both local residents and tourists.
`,

                facts: [
                    "Located in the city of Andijan",
                    "Established in 1994",
                    "Babur was born in Andijan in 1483",
                    "Contains a section dedicated to the Baburnama",
                    "Preserves maps of the Mughal Empire",
                    "A monument to Babur is located in the park",
                    "Built with modern landscape design",
                    "Displays copies of historical manuscripts",
                    "One of the most famous cultural sites in Andijan",
                    "Visited by thousands of guests every year",
                    "Used as an educational place for students",
                    "Provides information about the history of the Mughal Empire",
                    "Surrounded by a beautiful park area",
                    "Considered a symbol of national pride",
                    "One of the cultural centers of the Fergana Valley"
                ],

                images: [bobur1, bobur2, bobur3,]
            },
            {
                title: "Yodgorlik Street and Silk Craft — Margilan",

                content: `
Margilan is one of the oldest cities of the Fergana Valley and has been known for centuries as a world-famous center of silk production and traditional craftsmanship.

The historic Yodgorlik Street in the city center is famous for its unique wooden architecture and preserved traditions of local artisans.

Margilan is internationally recognized as the homeland of "khan-atlas", a traditional colorful silk fabric.
`,

                details: `
Margilan was one of the important stops on the Great Silk Road, and the city name has been mentioned in ancient historical sources.

📌 Silk production traditions:
- The "Yodgorlik" silk factory has more than 100 years of history
- Khan-atlas, a unique colorful silk fabric, is produced here
- Traditional methods of silkworm breeding and silk weaving are still preserved

📌 Yodgorlik Street:
- Preserves wooden houses dating back to the 19th and early 20th centuries
- Features decorated doors and columns with traditional carvings
- Represents a unique example of local architectural style

Today, Margilan remains one of the main centers of traditional crafts, where masters continue skills passed down from generation to generation.
`,

                facts: [
                    "An ancient city located in the Fergana Valley",
                    "Was an important stop on the Great Silk Road",
                    "A center of khan-atlas silk production",
                    "The Yodgorlik silk factory has more than 100 years of history",
                    "Traditional wooden houses are preserved on Yodgorlik Street",
                    "Traditional decorative arts are highly developed",
                    "Silkworm breeding traditions continue today",
                    "One of the main centers of Uzbek national textiles",
                    "Craft workshops are open for tourists",
                    "The local architectural style is considered unique",
                    "Known as the craft capital of the Fergana Valley",
                    "Silk products are exported to many countries",
                    "The city has a history spanning thousands of years",
                    "Famous for its traditional markets",
                    "A unique place preserving national craftsmanship"
                ],

                images: [margilon1, margilon2, margilon3,]
            },
            {
                title: "Rishtan Pottery Center",

                content: `
Rishtan is an ancient city in the Fergana Valley, famous throughout the world for its unique pottery traditions.

The special local clay and traditional glazing techniques make Rishtan pottery different from other schools of ceramics. The works are usually decorated with distinctive blue and turquoise colors.

Today, the city attracts tourists with its traditional craft workshops and pottery museums.
`,

                details: `
The pottery tradition of Rishtan has a history of more than 800 years and has been passed down from generation to generation.

📌 Unique features:
- Special local "zang" clay is found only in this region
- Traditional alkaline glazing techniques are used
- Famous colors such as "ishqor" and "lojuvard" are characteristic of Rishtan ceramics

📌 Famous craftsmen:
- Rishtan pottery families have preserved their skills for centuries
- Masters such as Zahid Mukhtorov have introduced this school of pottery to the world

📌 Museums and workshops:
The city has pottery museums and many active workshops where visitors can watch the process of creating traditional ceramic products.

Rishtan pottery remains one of the most valuable examples of Uzbek applied arts.
`,

                facts: [
                    "Located in the Fergana Valley near Fergana city",
                    "Pottery traditions have more than 800 years of history",
                    "Special local 'zang' clay is found only in this area",
                    "Famous for blue and turquoise colors",
                    "Traditional glazing techniques are still used",
                    "Pottery skills are passed from generation to generation",
                    "Modern masters have made the school famous worldwide",
                    "The city has a pottery museum",
                    "Many active craft workshops operate here",
                    "Rishtan ceramics are displayed in museums around the world",
                    "A unique school of Uzbek applied arts",
                    "Tourists can observe the production process",
                    "Rishtan pottery is recognized as national cultural heritage",
                    "A pottery festival is held every year",
                    "One of the main centers of traditional crafts in the Fergana Valley"
                ],

                images: [rishton1, rishton2, rishton3,]
            },
            {
                title: "Mulla Kyrgyz Mosque — Namangan",

                content: `
Mulla Kyrgyz Mosque is one of the largest and most impressive historical mosques in Namangan. In the past, it served as an important religious and educational center of the city.

The mosque stands out with its magnificent entrance portal and elegant brick decorations, representing a remarkable example of Fergana Valley architecture.

Today, the mosque continues to function as an active place of worship.
`,

                details: `
The mosque was built in the second half of the 19th century. According to historical sources, its construction was supported by a wealthy local merchant.

📌 Architectural features:
- A large entrance portal and a high dome
- Geometric patterns made of baked bricks
- Wooden columns and traditional carvings inside the prayer hall
- Rich decorative elements typical of the Fergana Valley style

📌 Historical importance:
- Served as an educational center during its time
- Played an important role in the religious life of Namangan
- Was partially used for other purposes during the Soviet period and later restored

The mosque is one of the most important historical landmarks of Namangan and an important part of the city's cultural heritage.
`,

                facts: [
                    "Located in Namangan city",
                    "Built in the second half of the 19th century",
                    "One of the largest mosques in the Fergana Valley",
                    "Famous for its baked brick decorations",
                    "Has a large entrance portal and a high dome",
                    "Wooden columns are preserved inside the prayer hall",
                    "Was an educational center during its period",
                    "Was a central place of religious life in Namangan",
                    "Was partially used for other purposes during the Soviet period",
                    "Later restored to its original function",
                    "Currently operates as an active mosque",
                    "A remarkable example of Fergana Valley architecture",
                    "One of the most famous historical monuments of Namangan",
                    "Regularly visited by local residents",
                    "Its central location attracts many visitors"
                ],

                images: [namangan1, namangan2, namangan3,]
            },
            {
                title: "Ancient City of Aksikent",

                content: `
Aksikent is one of the oldest and once one of the largest cities of the Fergana Valley. During the medieval period, it was considered the capital of the region.

Today, the city remains as an archaeological site and serves as a valuable source of knowledge for researchers and historians.

Aksikent plays an important role in studying the ancient civilization and history of the Fergana Valley.
`,

                details: `
Aksikent existed from ancient times and reached its peak during the medieval period as the main city of the Fergana region.

📌 Historical information:
- The city was located in a strategic position on the banks of the Syr Darya River
- It was an important stop on the Great Silk Road
- It reached its highest development during the 9th–12th centuries

📌 Destruction of the city:
In 1219, Aksikent was destroyed by the armies of Genghis Khan, but it was partially rebuilt later. In the 16th century, after a devastating earthquake, the city was completely abandoned.

📌 Archaeological importance:
- Excavations have revealed pottery, coins, and architectural remains
- The historical layers of the city allow researchers to study different periods of the Fergana Valley's history

Today, archaeological excavations continue at Aksikent, and it is considered an open-air museum.
`,

                facts: [
                    "Located in Namangan region on the banks of the Syr Darya River",
                    "Was the ancient capital of the Fergana Valley",
                    "Existed since ancient times before our era",
                    "Reached its peak during the 9th–12th centuries",
                    "Was an important stop on the Great Silk Road",
                    "Destroyed by Genghis Khan's armies in 1219",
                    "Completely abandoned after an earthquake in the 16th century",
                    "Archaeological excavations are still ongoing",
                    "Pottery, coins, and historical artifacts have been discovered",
                    "Considered an open-air museum",
                    "A key site for studying the history of the Fergana Valley",
                    "The city layers contain several historical periods",
                    "An important source for historians and archaeologists",
                    "Represents the ancient civilization of the region",
                    "One of the oldest historical monuments of Namangan"
                ],

                images: [axsikent1, axsikent2, axsikent3,]
            }
        ]
    },

    fr: {
        key: "fargona-vodiysi",
        title: "La vallée de Ferghana — un trésor historique aux trois régions",

        intro: `
La vallée de Ferghana est une région fertile entourée de montagnes, comprenant les régions de Ferghana, d’Andijan et de Namangan.

Depuis l’Antiquité, cette terre est un centre important de commerce, d’artisanat et de savoir. Elle est également connue comme le berceau de l’empire fondé par Zahiriddin Muhammad Babur.
`,

        history: `
La vallée de Ferghana est l’une des régions les plus anciennes et les plus fertiles d’Asie centrale, avec une histoire qui remonte à plusieurs milliers d’années.

Dans l’Antiquité, le royaume de Davan existait sur ce territoire. Les sources chinoises anciennes mentionnaient cette région comme la terre des célèbres « chevaux célestes », très appréciés dans le monde antique.

Une branche importante de la Grande Route de la Soie traversait la vallée de Ferghana, favorisant le développement de villes historiques comme Aksikent, Kokand, Andijan et Margilan.

La vallée occupe également une place majeure dans l’histoire mondiale grâce à Zahiriddin Muhammad Babur, né à Andijan, qui fonda plus tard l’Empire moghol en Inde.

Aux XVIIIᵉ et XIXᵉ siècles, le khanat de Kokand devint le centre politique de la région. Cette période fut marquée par la construction de nombreux palais, mosquées et madrasas.

Margilan devint célèbre pour sa production de soie et ses traditions artisanales, tandis que Rishtan fut reconnu pour son école unique de céramique.

Aujourd’hui, la vallée de Ferghana est l’une des régions les plus densément peuplées et culturellement riches d’Ouzbékistan, où se rencontrent histoire ancienne, traditions et modernité.
`,

        sections: [
            {
                title: "Le palais de Khudoyarkhan — Kokand",

                content: `
Le palais de Khudoyarkhan est le dernier et le plus somptueux palais du khanat de Kokand. Il est considéré comme l’un des monuments architecturaux les plus remarquables de la vallée de Ferghana.

À son époque, ce palais était l’une des plus grandes résidences royales d’Asie centrale et représentait la puissance, la richesse et le prestige du khanat de Kokand.

Aujourd’hui, une partie du palais fonctionne comme un musée historique ouvert aux visiteurs.
`,

                details: `
La construction du palais a commencé en 1863 et s’est achevée en 1873 sur ordre du khan de Kokand, Khudoyarkhan.

📌 Caractéristiques architecturales :
- À l’origine, le palais comptait 7 cours et plus de 100 pièces
- Décoré avec des carreaux de céramique colorés et des ornements en ganch sculpté
- Possédait un immense portail d’entrée et des tours décoratives

📌 Importance historique :
- Il fut la dernière résidence officielle des khans de Kokand
- Il fut partiellement détruit après la conquête de l’Empire russe
- Aujourd’hui, environ un quart du complexe original est conservé

Les décorations intérieures du palais, notamment les sculptures en ganch et les peintures traditionnelles, ont été réalisées par des artisans locaux sous la direction du maître Mir Ubaydulla.
`,

                facts: [
                    "Situé dans la ville de Kokand",
                    "Construit entre 1863 et 1873",
                    "Édifié sur ordre du khan Khudoyarkhan",
                    "Comptait à l’origine 7 cours et plus de 100 pièces",
                    "Dernière résidence du khanat de Kokand",
                    "Décoré avec des sculptures en ganch et des motifs en céramique",
                    "Partiellement détruit après la conquête russe",
                    "Abrite aujourd’hui un musée d’histoire locale",
                    "L’un des palais les plus célèbres de la vallée de Ferghana",
                    "Un exemple remarquable de l’architecture du XIXᵉ siècle",
                    "Les décorations intérieures présentent des motifs végétaux",
                    "Célèbre pour son immense portail d’entrée",
                    "Un centre important pour l’étude de l’histoire du khanat de Kokand",
                    "Visité chaque année par des milliers de touristes",
                    "Un symbole de l’histoire politique de la vallée de Ferghana"
                ],

                images: [xonsaroy1, xonsaroy2, xonsaroy3,]
            },
            {
                title: "Parc et musée de Babur — Andijan",

                content: `
Le parc et le musée de Babur sont situés dans la ville d’Andijan et rendent hommage à Zahiriddin Muhammad Babur, fondateur de l’Empire moghol et l’une des grandes figures historiques de l’Asie centrale.

Ce lieu est un important centre culturel et éducatif consacré à la vie de Babur, à ses œuvres et à l’histoire de l’Empire moghol.

Le parc associe un aménagement paysager moderne à une forte valeur historique et constitue aujourd’hui l’un des sites culturels les plus appréciés d’Andijan.
`,

                details: `
Le musée de Babur a été créé en 1994 à l’occasion du 510ᵉ anniversaire de la naissance du grand souverain et poète.

📌 Exposition :
- Manuscrits et copies liés à l’époque de Babur
- Une section consacrée à l’œuvre « Baburnama »
- Cartes de l’Empire moghol
- Exemples de vêtements et d’armes historiques

📌 Importance historique :
- Zahiriddin Muhammad Babur est né à Andijan en 1483
- Il est devenu dirigeant de la vallée de Ferghana dès son jeune âge
- Il a ensuite fondé l’Empire moghol en Inde

Dans le parc se trouvent une statue de Babur ainsi que de beaux espaces paysagers et des éléments aquatiques. Aujourd’hui, c’est un lieu apprécié par les habitants et les touristes.
`,

                facts: [
                    "Situé dans la ville d’Andijan",
                    "Créé en 1994",
                    "Babur est né à Andijan en 1483",
                    "Possède une section consacrée au « Baburnama »",
                    "Présente des cartes de l’Empire moghol",
                    "Une statue de Babur se trouve au centre du parc",
                    "Aménagé avec un design paysager moderne",
                    "Expose des copies de manuscrits historiques",
                    "L’un des sites culturels les plus connus d’Andijan",
                    "Accueille chaque année des milliers de visiteurs",
                    "Un lieu éducatif pour les élèves et les étudiants",
                    "Permet de découvrir l’histoire de l’Empire moghol",
                    "Entouré d’un espace vert agréable",
                    "Considéré comme un symbole de fierté nationale",
                    "L’un des centres culturels importants de la vallée de Ferghana"
                ],

                images: [bobur1, bobur2, bobur3,]
            },
            {
                title: "Rue Yodgorlik et artisanat de la soie — Margilan",

                content: `
Margilan est l’une des villes les plus anciennes de la vallée de Ferghana. Depuis des siècles, elle est reconnue comme un centre mondial de production de soie et d’artisanat traditionnel.

La rue Yodgorlik, située dans le centre historique de la ville, est célèbre pour son architecture en bois unique et pour la préservation des traditions artisanales locales.

Margilan est connue dans le monde entier comme le berceau du « khon-atlas », un tissu traditionnel ouzbek en soie aux couleurs éclatantes.
`,

                details: `
Margilan était autrefois une étape importante de la Grande Route de la Soie, et le nom de la ville apparaît dans plusieurs sources historiques anciennes.

📌 Tradition de la soie :
- La fabrique de soie « Yodgorlik » possède plus de 100 ans d’histoire
- Le khon-atlas, un tissu de soie traditionnel aux motifs colorés, y est fabriqué
- Les méthodes anciennes d’élevage des vers à soie et de tissage sont toujours conservées

📌 Rue Yodgorlik :
- Des maisons en bois datant du XIXᵉ et du début du XXᵉ siècle sont préservées
- Les portes et les colonnes sont décorées de sculptures traditionnelles
- Elle représente un exemple unique de l’architecture locale

Aujourd’hui, Margilan reste l’un des principaux centres de l’artisanat traditionnel. Les maîtres continuent de transmettre leur savoir-faire de génération en génération, préservant ainsi des techniques anciennes.
`,

                facts: [
                    "Ville ancienne située dans la vallée de Ferghana",
                    "Était une étape importante de la Grande Route de la Soie",
                    "Centre de production du tissu traditionnel khon-atlas",
                    "La fabrique de soie Yodgorlik possède plus de 100 ans d’histoire",
                    "Des maisons traditionnelles en bois sont conservées dans la rue Yodgorlik",
                    "L’art de la décoration traditionnelle y est développé",
                    "Les traditions de l’élevage des vers à soie existent encore aujourd’hui",
                    "L’un des principaux centres des textiles nationaux ouzbeks",
                    "Des ateliers d’artisans sont ouverts aux visiteurs",
                    "L’architecture locale est considérée comme unique",
                    "La capitale artisanale de la vallée de Ferghana",
                    "Les tissus en soie sont exportés dans de nombreux pays",
                    "L’histoire de la ville remonte à plusieurs milliers d’années",
                    "Connue également pour ses marchés traditionnels",
                    "Un lieu exceptionnel qui préserve les traditions artisanales nationales"
                ],

                images: [margilon1, margilon2, margilon3,]
            },
            {
                title: "Centre de céramique de Rishtan",

                content: `
Rishtan est une ancienne ville située dans la vallée de Ferghana, célèbre dans le monde entier pour son école unique de céramique traditionnelle.

L’argile locale spéciale et les techniques traditionnelles de glaçure donnent aux céramiques de Rishtan un caractère unique. Les œuvres sont généralement décorées avec des couleurs bleu turquoise et vert caractéristiques.

Aujourd’hui, la ville attire les visiteurs grâce à ses ateliers d’artisanat traditionnel et ses musées consacrés à la céramique.
`,

                details: `
La tradition de la céramique de Rishtan possède une histoire de plus de 800 ans et se transmet de génération en génération.

📌 Particularités :
- Une argile locale spéciale appelée « zang » est présente uniquement dans cette région
- Les artisans utilisent des techniques traditionnelles de glaçure à base alcaline
- Les couleurs célèbres « ishqor » et « lojuvard » caractérisent les œuvres de Rishtan

📌 Maîtres célèbres :
- Les familles de potiers de Rishtan préservent leur savoir-faire depuis plusieurs siècles
- Des maîtres comme Zahid Mukhtorov ont contribué à faire connaître cette école dans le monde entier

📌 Musées et ateliers :
La ville possède un musée de la céramique ainsi que plusieurs ateliers actifs où les touristes peuvent observer directement le processus de fabrication des objets traditionnels.

La céramique de Rishtan reste aujourd’hui l’un des exemples les plus précieux de l’art décoratif ouzbek.
`,

                facts: [
                    "Situé dans la vallée de Ferghana près de la ville de Ferghana",
                    "La tradition de la céramique possède plus de 800 ans d’histoire",
                    "L’argile locale « zang » est unique à cette région",
                    "Célèbre pour ses couleurs bleu turquoise et vert",
                    "Les techniques traditionnelles de glaçure sont toujours utilisées",
                    "Le savoir-faire des potiers est transmis de génération en génération",
                    "Les artisans modernes ont fait connaître cette école dans le monde",
                    "La ville possède un musée de la céramique",
                    "De nombreux ateliers d’artisans fonctionnent encore aujourd’hui",
                    "Les œuvres de Rishtan sont exposées dans plusieurs musées du monde",
                    "Une école unique de l’art décoratif ouzbek",
                    "Les touristes peuvent observer le processus de fabrication",
                    "La céramique de Rishtan est reconnue comme un patrimoine national",
                    "Un festival de céramique est organisé chaque année",
                    "L’un des principaux centres d’artisanat traditionnel de la vallée de Ferghana"
                ],

                images: [rishton1, rishton2, rishton3,]
            },
            {
                title: "Mosquée Mulla Kyrgyz — Namangan",

                content: `
La mosquée Mulla Kyrgyz est l’une des plus grandes et des plus impressionnantes mosquées historiques de la ville de Namangan. À son époque, elle était un important centre religieux et éducatif de la région.

Elle se distingue par son immense portail d’entrée et ses magnifiques décorations en briques, représentant un exemple remarquable de l’architecture de la vallée de Ferghana.

Aujourd’hui encore, la mosquée reste un lieu de culte actif.
`,

                details: `
La mosquée a été construite dans la seconde moitié du XIXᵉ siècle. Selon certaines sources historiques, sa construction a été soutenue par un riche marchand local.

📌 Caractéristiques architecturales :
- Un grand portail d’entrée et un haut dôme
- Des motifs géométriques réalisés en briques cuites
- Des colonnes en bois et des sculptures traditionnelles dans la salle de prière
- Des décorations riches caractéristiques du style architectural de la vallée de Ferghana

📌 Importance historique :
- Elle était autrefois un centre d’enseignement religieux
- Elle occupait une place centrale dans la vie spirituelle de Namangan
- Durant la période soviétique, elle a été partiellement utilisée pour d’autres fonctions avant d’être restaurée

La mosquée Mulla Kyrgyz est aujourd’hui l’un des monuments historiques les plus importants de Namangan et un élément précieux du patrimoine culturel de la ville.
`,

                facts: [
                    "Située dans la ville de Namangan",
                    "Construite dans la seconde moitié du XIXᵉ siècle",
                    "L’une des plus grandes mosquées de la vallée de Ferghana",
                    "Célèbre pour ses décorations en briques cuites",
                    "Possède un grand portail et un haut dôme",
                    "Des colonnes en bois sont conservées à l’intérieur",
                    "Était un centre éducatif à son époque",
                    "Était un centre important de la vie religieuse de Namangan",
                    "A été utilisée partiellement à d’autres fins pendant la période soviétique",
                    "A ensuite été restaurée",
                    "Fonctionne aujourd’hui comme une mosquée active",
                    "Un exemple remarquable de l’architecture de la vallée de Ferghana",
                    "L’un des monuments historiques les plus connus de Namangan",
                    "Régulièrement visitée par les habitants",
                    "Sa position centrale attire de nombreux visiteurs"
                ],

                images: [namangan1, namangan2, namangan3,]
            }, {
                title: "Ancienne ville d’Aksikent",

                content: `
Aksikent est l’une des villes les plus anciennes et autrefois l’une des plus grandes de la vallée de Ferghana. Au Moyen Âge, elle était considérée comme la capitale de la région.

Aujourd’hui, la ville est conservée sous forme de ruines archéologiques et représente une source scientifique précieuse pour les historiens et les chercheurs.

Aksikent joue un rôle essentiel dans l’étude de la civilisation ancienne et de l’histoire de la vallée de Ferghana.
`,

                details: `
Aksikent existait déjà dans l’Antiquité et a connu son âge d’or au Moyen Âge en devenant le principal centre politique et économique de la région de Ferghana.

📌 Informations historiques :
- La ville était située dans un emplacement stratégique sur les rives du Syr-Daria
- Elle constituait une étape importante de la Grande Route de la Soie
- Elle a atteint son apogée entre les IXᵉ et XIIᵉ siècles

📌 Destruction de la ville :
En 1219, Aksikent fut détruite par les armées de Gengis Khan, mais elle fut partiellement reconstruite par la suite. Au XVIᵉ siècle, après un puissant tremblement de terre, la ville fut définitivement abandonnée.

📌 Importance archéologique :
- Les fouilles ont permis de découvrir des objets en céramique, des pièces de monnaie et des vestiges architecturaux
- Les différentes couches historiques du site permettent d’étudier l’évolution de la vallée de Ferghana à travers les siècles

Aujourd’hui, les recherches archéologiques continuent à Aksikent, qui est considéré comme un véritable musée à ciel ouvert.
`,

                facts: [
                    "Située dans la région de Namangan, au bord du Syr-Daria",
                    "Ancienne capitale de la vallée de Ferghana",
                    "Existait déjà avant notre ère",
                    "A connu son apogée entre les IXᵉ et XIIᵉ siècles",
                    "Était une étape importante de la Grande Route de la Soie",
                    "Détruite par les armées de Gengis Khan en 1219",
                    "Abandonnée définitivement après un tremblement de terre au XVIᵉ siècle",
                    "Les fouilles archéologiques continuent encore aujourd’hui",
                    "Des céramiques, monnaies et objets historiques ont été découverts",
                    "Considérée comme un musée à ciel ouvert",
                    "Un site essentiel pour comprendre l’histoire de la vallée de Ferghana",
                    "Ses couches archéologiques couvrent plusieurs périodes historiques",
                    "Une source importante pour les historiens et archéologues",
                    "Témoigne de l’ancienne civilisation de la région",
                    "L’un des plus anciens monuments historiques de la région de Namangan"
                ],

                images: [axsikent1, axsikent2, axsikent3,]
            }
        ]
    }
};

export default fargonaVodiysi;